/* Remove an applied discount code from the cart line-item tag (the small X).
   Mirrors the theme's own cart-discount component: POST the new discount list to
   the cart update URL, then morph the cart section so the drawer/page updates in
   place — no reload, no redirect.

   Kept deliberately simple: clearing sends an empty discount list, which removes
   all code-type discounts. For a single welcome code that's all that's needed; if
   stacked codes are ever used this would need to send the remaining codes. */
import { morphSection } from '@theme/section-renderer';
import { fetchConfig } from '@theme/utilities';

if (!window.__ggCartCouponInit) {
  window.__ggCartCouponInit = true;

  document.addEventListener('click', async (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const remove = target.closest('.gg-cart-coupon__remove');
    if (!(remove instanceof HTMLElement)) return;

    const host = remove.closest('[data-section-id]');
    const sectionId = host instanceof HTMLElement ? host.dataset.sectionId : null;
    if (!sectionId) return;

    event.preventDefault();

    try {
      const config = fetchConfig('json', {
        body: JSON.stringify({ discount: '', sections: [sectionId] }),
      });
      const response = await fetch(Theme.routes.cart_update_url, config);
      const data = await response.json();
      if (data.sections?.[sectionId]) {
        morphSection(sectionId, data.sections[sectionId]);
      }
    } catch (_) {
      /* non-fatal — leave the tag in place if the request fails */
    }
  });
}
